<template>
  <div>
    <div
      :class="$isMobile ? 'text-h5' : 'text-h4 mt-18'"
      class="mb-2 primary-grey--text font-weight-regular"
    >
      Hi {{ userName }},
    </div>
    <div
      :class="$isMobile ? 'text-h6' : 'text-h5'"
      class="mb-2 primary-grey--text font-weight-regular"
    >
      I'm Sinoa, your Grain Market Assistant.
    </div>
    <div
      :class="$isMobile ? 'text-body-1' : 'text-h5'"
      class="primary-grey--text font-weight-regular"
    >
      How can I help you today?
    </div>
    <br>
    <br v-if="!$isMobile">
    <div
      :class="$isMobile ? 'text-body-2': 'text-body-1'"
      class="primary-grey--text"
    >
      New to Sinoa?
      <span
        :style="{ color: COLORS.grainfoxAIButton, cursor: 'pointer' }"
        class="font-weight-bold"
        @click="openSinoaGuideDialog = true"
      >
        Check our Guide
      </span>
      to find out what I can do!
    </div>
    <SinoaGuideDialog
      :value="openSinoaGuideDialog"
      @input="openSinoaGuideDialog = false"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { COLORS } from '@/helpers/colors';
import SinoaGuideDialog from './SinoaGuideDialog.vue';

export default {
  name: 'SinoaWelcome',

  components: {
    SinoaGuideDialog,
  },

  data() {
    return {
      COLORS,
      openSinoaGuideDialog: false,
    };
  },

  computed: {
    ...mapState('user', ['firstName']),

    userName() {
      return this.firstName || 'User';
    },
  },
};
</script>
